import { create } from 'zustand'
import type { Notification } from '../types'

interface NotifStore {
  unreadCount: number
  toasts: Notification[]
  setUnreadCount: (count: number) => void
  incrementUnread: () => void
  decrementUnread: () => void
  pushToast: (notification: Notification) => void
  dismissToast: (id: string) => void
}

export const useNotifStore = create<NotifStore>((set) => ({
  unreadCount: 0,
  toasts: [],

  setUnreadCount: (count: number) => set({ unreadCount: count }),

  incrementUnread: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),

  decrementUnread: () =>
    set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) })),

  pushToast: (notification: Notification) =>
    set((state) => {
      const nextToasts = [
        notification,
        ...state.toasts.filter((toast) => toast.id !== notification.id),
      ].slice(0, 4)
      return { toasts: nextToasts }
    }),

  dismissToast: (id: string) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
}))
